import { render, staticRenderFns } from "./CampoRecepcionFebos.vue?vue&type=template&id=2303467c&scoped=true&"
import script from "./CampoRecepcionFebos.vue?vue&type=script&lang=js&"
export * from "./CampoRecepcionFebos.vue?vue&type=script&lang=js&"
import style0 from "./CampoRecepcionFebos.vue?vue&type=style&index=0&id=2303467c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2303467c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2303467c')) {
      api.createRecord('2303467c', component.options)
    } else {
      api.reload('2303467c', component.options)
    }
    module.hot.accept("./CampoRecepcionFebos.vue?vue&type=template&id=2303467c&scoped=true&", function () {
      api.rerender('2303467c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dte/componentes/campos/CampoRecepcionFebos.vue"
export default component.exports